<template>
	<v-container fluid class="ma-0 pa-0">
    <StoreHeader />
    <v-row class="ma-0 pa-0">
      <LeftStoreDetailNav />
      <v-col class="ma-0 pa-0" cols="10">
        <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
          <!-- <v-row class="ma-0 pa-5 pb-1" align="center" justify="end">
            <v-btn id="blue_btn" width="10rem" height="2rem"
              class="ma-0 pa-0" elevation="0" @click="goStoreMapEdit">
              {{'マップの編集'}}
            </v-btn>
          </v-row>
          <v-row class="ma-0 pa-5 pt-0 pb-10" align="center" justify="center">
            <v-col class="ma-0 pa-0" cols="auto">
              <v-img height="12rem" width="15rem" class="ma-0 pa-0"
                src="@/assets/images/store_map_test1.png"></v-img>
            </v-col>
            <v-col class="ma-0 pa-0 ml-5" cols="auto">
              <v-img height="12rem" width="15rem" class="ma-0 pa-0"
                src="@/assets/images/store_map_test2.png"></v-img>
            </v-col>
          </v-row> -->
          <v-row class="ma-0 pa-5 pt-10">
            <v-col class="ma-0 pa-0">
					    <v-row class="ma-0 pa-0" align="center"
                v-if="fetchLoading == false">
								<template v-if="cameraList.length > 0">
									<v-col class="ma-0 pa-2" id="camera_cctv_box" cols="4" 
										v-for="(item, index) in cameraList" :key="index">
										<ThumbnailListItem
											:item="item" :index="index" :imgLoaders="imgLoaders"
											:streamingUrlLoading="fetchLoading" @onLoad="onLoadFunc" />
									</v-col>
								</template>
								<template v-else>
									<v-col class="ma-0 pa-15" cols="12">
										{{t('noCamera')}}
									</v-col>
								</template>
					    </v-row>
              <template v-else>
                <ImageSkeleton :loaderCount="9" width='100%' height='208px' />
              </template>
            </v-col>
          </v-row>
		    </v-col>
      </v-col>
    </v-row>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import StoreHeader from './components/StoreHeader.vue';
import LeftStoreDetailNav from './components/LeftStoreDetailNav.vue';
import ImageSkeleton from '@/components/loader/ImageSkeleton.vue';
import ThumbnailListItem from '@/components/ThumbnailListItem.vue';
export default {
	components: {
    StoreHeader, LeftStoreDetailNav, ImageSkeleton, ThumbnailListItem
	},
	mixins: [mixin.common],
	data: () => ({
    unisCustomerCd: '',
    storeData: {},
    cameraList: [],
    fetchLoading: false,
    deviceStatusList: ['5', '10', '12', '17', '19', '20'],
		imgLoaders: [],
	}),
	created() {
		this.unisCustomerCd = this.$route.query.unisCustomerCd;
    this.storeData = this.$store.getters.getStoreData;
		for(var i = 0; i < 99; i++) {
			this.imgLoaders.push(true)
		}
  },
  mounted() {
    this.getStoreCameraList();
  },
  methods: {
    goStoreMapEdit() {
      this.pushRoute('/store-search/store-map', {unisCustomerCd: this.unisCustomerCd});
    },
    async getStoreCameraList() {
      this.fetchLoading = true;
			this.imgLoaders = [];
			for(var i = 0; i < 99; i++) {
				this.imgLoaders.push(true)
			}
      let params = {};
      await this.networkController.getStoreCameraList(params, this.unisCustomerCd, '', '', '', '', '')
      .then(async (res) => {
				console.log('%cCameraList\n', "color:#008DD0;", res.data);
				let storeCamerasList = [];
				res.data.forEach((item) => {
					if(this.checkVideoStreamAvailable(item) == false) {
						let data = item;
						data.streamAble = false;
						if(item.isUas == false) {
							storeCamerasList.push(data);
						}
					} else {
						let data = item;
						data.streamAble = true;
						storeCamerasList.push(data);
					}
				});
				this.cameraList = storeCamerasList;
				this.fetchLoading = false;
      }).catch(error => {
        this.fetchLoading = false;
      });
    },
		onLoadFunc(data) {
			this.imgLoaders.splice(data.index, 1, data.value);
		},
  }
}
</script>

<style lang="scss" scoped>
#middle_divider {
	background-color: #4C4C4C;
}
#nav_list {
  background: #1D202C;
  border: none;
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__title{
    color: white;
  }
}
#thumbnail_title_box {
	background-color: rgba(0, 0, 0, 0.5);
	color: #BEBEBE;
	font-size: 0.9rem;
}
#thumbnail_date {
	color: #BEBEBE;
	font-size: 0.7rem;
	text-align: left;
}
#camera_cctv_box {
  position: relative;
}
#camera_cctv_btn {
	position: absolute;
	top: 1rem;
  right: 1rem;
	z-index: 3;
}
.not_streaming_box {
  height: 11rem;
  text-align:center;
  justify-content: center;
  align-items: center;
  background: grey;
}
.no_data_box_style{
  height: 11rem;
  line-height: 11rem;
  text-align: center;
  background: grey;
  color: white;
  display: none;
}
</style>